import React, { useEffect, useRef, useState } from 'react'
import maplibregl, { Map } from 'maplibre-gl'
import style from './mapStyles.json'
import './defaultMap.scss'
import 'maplibre-gl/dist/maplibre-gl.css'

interface IProps {
  children?: React.ReactNode,
  className?: string
}

const DefaultMap = ({ children, className }: IProps) => {
  const [map, setMap] = useState<Map>()
  const [isMapLoaded, setIsMapLoaded] = useState(false)
  const mapRef = useRef(null)

  useEffect(() => {
    const node = mapRef.current
    if (typeof window === 'undefined' || node === null) return
    const mapboxMap = new maplibregl.Map({
      container: node,
      style: style as any,
      center: [-73.801699957496, 40.666413302033],
      zoom: 8
    })
    mapboxMap.on('load', () => {
      mapboxMap.resize()
      setIsMapLoaded(true)
    })
    setMap(mapboxMap)
    return () => {
      mapboxMap.remove()
    }
  }, [])

  return (
    <div style={{ minWidth: '400px' }} ref={mapRef} className={className}>
      {isMapLoaded ? React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement<React.ComponentProps<typeof child.props>>(child, { map })
        }
        return child
      }) : null}
    </div>
  )
}

export default DefaultMap

